import {MI} from "../init";
import {AbstractSymbol} from "../symbol/AbstractSymbol";
import {he_scale, systemConfig, wi, wi_scale} from "../../framework/src/engine/madnes/madnes_variables";
import {madnes_get_json} from "../../framework/src/engine/madnes/madnes";
import {wintable_phaser} from "../../framework/src/engine/madnes/MadnesApp";
import {CONFIG_PARAMS} from "../../framework/src/system/SystemConfig";

/**
 * @constructor
 */
export function GameInfo() {

    /**
     * @type {SymbolsManager}
     */
    this._symbolsManager;

    /**
     * @constant
     * @type {number}
     */
    this._slideDuration = 400;

    /**
     * @type {ServerCfg}
     */
    this._serverConfig;

    /**
     * @private
     * @type {Array<MadnesGroup>}
     */
    this._slidesGroups = [];

    /** @type {MadnesObject} */
    this._cover1;

    /** @type {MadnesObject} */
    this._logo;

    /**
     * @type {number}
     */
    this._pos = 0;

    /**
     * @type {number}
     */
    this._prevPos = 0;

    /** @type {!Object<string, MadnesObject>} */
    this._texts = {};

    /** @type {!Array<MadnesObject>} */
    this._slidesBgs = [];

    /** @type {Array<MadnesObject>} */
    this._objects = [];

    /** @type {MadnesGroup} */
    this._coverGroup;

    /** @type {boolean} */
    this._locked = false;

    this.opened = false;

    this._phaser;

    this._slideCallbackOnce = null;

    this._tween1 = null;
    this._tween2 = null;
};

/**
 * @param {ServerCfg} serverConfig
 * @param {SymbolsManager} symbolsManager
 */
GameInfo.prototype.init = function(serverConfig, symbolsManager) {
    this._symbolsManager = symbolsManager;
    this._serverConfig = serverConfig;

    this._phaser = wintable_phaser;

    for(var i = 0; i < 5; i++) {
        this._slidesGroups.push(MI.addGroup("infotable_group_" + i, this._phaser));
    }

    this._coverGroup = MI.addGroup("group_cover", this._phaser);
};

GameInfo.prototype.create = function() {

    this._cover1 = MI.addImg(0, 0, "reels_atlas", "wintable_reels_1", this._phaser).setFrameName("reels_cover_01");
    this._cover2 = MI.addImg(0, MI.getHe(), "reels_atlas", "wintable_reels_2", this._phaser).setFrameName("reels_cover_02").setAnchor(0, 1);

    this._logo = MI.addImg(MI.getWi() / 2 + 4, -2, "reels_atlas", "wintable_logo", this._phaser).setFrameName("logo");
    this._logo.setAnchor(0.5, 0);

    this._coverGroup.add(this._cover1);
    this._coverGroup.add(this._cover2);
    this._coverGroup.add(this._logo);

    for(var i = 0; i < this._slidesGroups.length; i++) {
        this._slidesGroups[i].add(MI.addImg(0, 0, "info_background", "wintable_info_bg" + i, this._phaser));
    }

    this._objects[0] = MI.addImg(0, 0, "wintable_1", "wintable_1", this._phaser);
    this._objects[1] = MI.addImg(0, 0, "wintable_2", "wintable_2", this._phaser);
    this._objects[2] = MI.addImg(MI.getWi() / 2, MI.getHe() / 2 + 10, "winlines", "winlines", this._phaser).setAnchor(0.5, 0.5); //.setScale(0.9, 0.9);

    this._slidesGroups[0].add(this._objects[0]);
    this._slidesGroups[1].add(this._objects[1]);
    this._slidesGroups[4].add(this._objects[2]);

//	var style = {
//		"font": "36px TeXGyrePagella",
//		"fill": "#fff160",
//		"fontWeight": "bold",
//		"strokeThickness": 2,
//		//"strokeColor": "#000000"
//	};

    var txt = "";

    this._texts = {
        'symbol_Woman_5': MI.addBitmapText("font_wintable", 1120, 166 - 12, txt, 80),
        'symbol_Woman_4': MI.addBitmapText("font_wintable", 1120, 166 + 51 - 12, txt, 80),
        'symbol_Woman_3': MI.addBitmapText("font_wintable", 1120, 166 + 104 - 12, txt, 80),
        'symbol_Woman_2': MI.addBitmapText("font_wintable", 1120, 166 + 152 - 12, txt, 80),

        'symbol_Viking_5': MI.addBitmapText("font_wintable", 564, 166 - 12, txt, 80), //MI.addBitmapText("font_wintable", 920, 80, txt, 80),
        'symbol_Viking_4': MI.addBitmapText("font_wintable", 564, 166 + 52 - 12, txt, 80),
        'symbol_Viking_3': MI.addBitmapText("font_wintable", 564, 166 + 104 - 12, txt, 80),
        'symbol_Viking_2': MI.addBitmapText("font_wintable", 564, 166 + 154 - 12, txt, 80),

        'symbol_Helmet_5':  MI.addBitmapText("font_wintable", 564, 482 - 12, txt, 80),
        'symbol_Helmet_4':  MI.addBitmapText("font_wintable", 564, 482 + 48 - 12, txt, 80),
        'symbol_Helmet_3':  MI.addBitmapText("font_wintable", 564, 482 + 98 - 12, txt, 80),

        'symbol_Axe_5':  MI.addBitmapText("font_wintable", 1120, 484 - 12, txt, 80),
        'symbol_Axe_4':  MI.addBitmapText("font_wintable", 1120, 484 + 48 - 12, txt, 80),
        'symbol_Axe_3':  MI.addBitmapText("font_wintable", 1120, 484 + 98 - 12, txt, 80),

        'symbol_Shield_5':  MI.addBitmapText("font_wintable", 564, 190 - 12, txt, 80),
        'symbol_Shield_4':  MI.addBitmapText("font_wintable", 564, 190 + 48 - 12, txt, 80),
        'symbol_Shield_3':  MI.addBitmapText("font_wintable", 564, 190 + 98 - 12, txt, 80),

        'symbol_Bracelet_5':  MI.addBitmapText("font_wintable", 1120, 192 - 12, txt, 80),
        'symbol_Bracelet_4':  MI.addBitmapText("font_wintable", 1120, 192 + 48 - 12, txt, 80),
        'symbol_Bracelet_3':  MI.addBitmapText("font_wintable", 1120, 192 + 98 - 12, txt, 80),

        'symbol_Q_5':  MI.addBitmapText("font_wintable", 1120, 482 - 12, txt, 80),
        'symbol_Q_4':  MI.addBitmapText("font_wintable", 1120, 484 + 48 - 12, txt, 80),
        'symbol_Q_3':  MI.addBitmapText("font_wintable", 1120, 484 + 98 - 12, txt, 80),

        'symbol_K_5':  MI.addBitmapText("font_wintable", 564, 482 - 12, txt, 80),
        'symbol_K_4':  MI.addBitmapText("font_wintable", 564, 484 + 48 - 12, txt, 80),
        'symbol_K_3':  MI.addBitmapText("font_wintable", 564, 484 + 98 - 12, txt, 80)

//		"scatter_1": MI.addText(890, 324, "WIN x2", style),
//		"scatter_2": MI.addText(890, 404, "WIN x4", style),
//		"scatter_3": MI.addText(890, 484, "WIN x8", style),
//		"scatter_4": MI.addText(890, 564, "WIN x18", style)
    };

    var keys = Object.keys(this._texts);

    for(var i = 0; i < keys.length; i++) {
        var key = keys[i];
        //this._texts[key].setTextShadow(0, 0, 'rgba(0,0,0,1)', 10);
        this._texts[key].setAnchor(1, 1);
    }

    for(var i = 2; i <= 5; i++) {
        this._slidesGroups[0].add(this._texts["symbol_Woman_" + i]);
        this._slidesGroups[0].add(this._texts["symbol_Viking_" + i]);
    }

    for(var i = 3; i <= 5; i++) {
        this._slidesGroups[0].add(this._texts["symbol_Helmet_" + i]);
        this._slidesGroups[0].add(this._texts["symbol_Axe_" + i]);

        this._slidesGroups[1].add(this._texts["symbol_Shield_" + i]);
        this._slidesGroups[1].add(this._texts["symbol_Bracelet_" + i]);
        this._slidesGroups[1].add(this._texts["symbol_Q_" + i]);
        this._slidesGroups[1].add(this._texts["symbol_K_" + i]);
    }

//	for(var i = 1; i <= 4; i++) {
//		this._slidesGroups[2].add(this._texts["scatter_" + i]);
//	}

    var infotexts = madnes_get_json("infotext")['infomenuPages'];

    var wild = MI.addImg(220, 420, "info_symbols_atlas").setFrameName("symbol_Wild");
    wild.setAnchor(0.5, 0.5);
    this._objects.push(wild);
    this._slidesGroups[2].add(wild);

	if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
        var freeSpins = MI.addImg(350, 90, "10x_free_spins_es");
    } else {
        var freeSpins = MI.addImg(350, 90, "10x_free_spins");
    }
    this._objects.push(freeSpins);
    this._slidesGroups[3].add(freeSpins);

    var scatter = MI.addImg(220, 380, "info_symbols_atlas").setFrameName("symbol_Scatter");
    scatter.setAnchor(0.5, 0.5);
    this._objects.push(scatter);
    this._slidesGroups[3].add(scatter);

    for(var i = 0; i < infotexts.length; i++) {

        var x = infotexts[i]["position"][0];
        var y = infotexts[i]["position"][1];

        var page = infotexts[i]["page"];
        var lineHeight0 = infotexts[i]['title'] ? infotexts[i]['title']["lineHeight"] : 0;
        var lineHeight1 = infotexts[i]["lineHeight"];

        var style0 = {
            "font": "32px Arial",
            "fill": "#faba41",
            "fontWeight": ""
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": ""
        };

        if(infotexts[i]["fontSize"] && infotexts[i]["font"])
        {
            style0["font"] = infotexts[i]["fontSize"] + "px " + infotexts[i]["font"];
            style1["font"] = infotexts[i]["fontSize"] + "px " + infotexts[i]["font"];
        }

        if(infotexts[i]["boundsAlignH"]) {
            style0["boundsAlignH"] = infotexts[i]["boundsAlignH"];
        }

        if(infotexts[i]["boundsAlignH"]) {
            style0["boundsAlignV"] = infotexts[i]["boundsAlignV"];
        }

        var line0 = 0;
        var line1 = 0;

        if(infotexts[i]["title"] && infotexts[i]["title"]["content"].length) {

            style0["fill"] = infotexts[i]["title"]["color"];
            style0["fontWeight"] = infotexts[i]["title"]["bold"] === 1 ? "bold" : "";

            for(var j = 0; j < infotexts[i]["title"]["content"].length; j++) {

                var text1 = infotexts[i]["title"]["content"][j];

                var t1 = MI.addText(x, y + line0 * lineHeight0, text1, style0);

                if(infotexts[i]["setTextBounds"]) {
                    var tb = infotexts[i]["setTextBounds"];
                    t1.setTextBounds(tb[0] * wi_scale, tb[1] * he_scale, tb[2] * wi_scale, tb[3] * he_scale);
                }

                this._slidesGroups[page - 1].add(t1);
                this._objects.push(t1);
                line0++;
            }
        }

        if(infotexts[i]["body"] && infotexts[i]["body"]["content"].length) {

            style1["fill"] = infotexts[i]["body"]["color"];
            style1["fontWeight"] = infotexts[i]["body"]["bold"] === 1 ? "bold" : "";

            for(var j = 0; j < infotexts[i]["body"]["content"].length; j++) {
                var text2 = infotexts[i]["body"]["content"][j];
                var t2 = MI.addText(x, y + line0 * lineHeight0 + line1 * lineHeight1, text2, style1);

                this._slidesGroups[page - 1].add(t2);
                this._objects.push(t2);

                line1++;
            }
        }

        //console.log(style1["fontWeight"], style0["fontWeight"]);
    }

    this._hideAllSlides();
};

GameInfo.prototype.update = function(bet) {

    if(!this._slidesGroups.length) {
        return;
    }

    var symbols = this._serverConfig.getSymbols();
    for(var i = 0; i < symbols.length; i++) {
        var factors = symbols[i]["factors"];
        var name = AbstractSymbol.getSymbolByNum(i);

        for(var factorIdx = 0; factorIdx < factors.length; factorIdx++) {
            var factor = factors[factorIdx];

            if(!factor) {
                factor = 1;
            }

            if(typeof this._texts[name + "_" + (factorIdx + 1)] === 'undefined') {
                continue;
            }

            this._texts[name + "_" + (factorIdx + 1)].setAdjustText(bet * factor, 9999);
        }
    }
};

GameInfo.prototype.open = function() {
    this._show(this._pos);
    this.opened = true;
};

GameInfo.prototype.slideLeft = function() {
    if(!this.opened) return;
    this._slide(-1, this._pos - 1);
};

GameInfo.prototype.slideRight = function() {
    if(!this.opened) return;
    this._slide(1, this._pos + 1);
};

GameInfo.prototype.showMain = function() {
    if(this._pos === 0) {
        return;
    }

    if(!this._locked) {
        this._slide(-1, 0);
    } else {
        this._slideCallbackOnce = () => {
            this._slide(-1, 0);
        }
    }
}

/**
 * @private
 * @param {number} dir
 * @returns {undefined}
 */
GameInfo.prototype._slide = function(dir, next) {

    if(this._locked) {
        return;
    }

    this._locked = true;

    this._prevPos = this._pos;

    this._pos = next; //this._pos + dir;

    if(this._pos < 0) {
        this._pos = this._slidesGroups.length - 1;
    }

    if(this._pos >= this._slidesGroups.length) {
        this._pos = 0;
    }

    this._tween1 = MI.addTween().to(this._slidesGroups[this._prevPos], { 'x': wi * dir * -1 }, {
        'duration': this._slideDuration,
        'callback': () => {
            this._slidesGroups[this._prevPos].setVisible(false);
        }
    });

    this._slidesGroups[this._pos].setVisible(true);
    this._slidesGroups[this._pos].setPosX(wi * dir);

    this._tween2 = MI.addTween().to(this._slidesGroups[this._pos], { 'x': 0 }, {
        'duration': this._slideDuration,
        'callback': () => {
            this._locked = false;
            this._slideCallbackOnce && this._slideCallbackOnce();
            this._slideCallbackOnce = null;
        }
    });
};

// GameInfo.prototype._slideMain = function(dir = -1, cb) {
// 	this._slidesGroups[0].setVisible(true);

// 	this._tween1 = MI.addTween().to(this._slidesGroups[0], { 'x': 0 }, {
// 		'duration': this._slideDuration,
// 		// 'callback': () => {
// 		// 	this._slidesGroups[pos].setVisible(false);
// 		// }
// 	});

// 	let pos = this._pos;

// 	this._tween2 = MI.addTween().to(this._slidesGroups[pos], { 'x': wi * dir * -1 }, {
// 		'duration': this._slideDuration,
// 		'callback': () => {
// 			this._slidesGroups[pos].setVisible(false);
// 			cb();
// 		}
// 	});

// 	this._pos = 0; 
// }

GameInfo.prototype.close = function() {

//	this._logo.kill();
//	this._cover.kill();

    this._hideAllSlides();
    this.opened = false;
};

GameInfo.prototype._show = function(slideId) {
    this._hideAllSlides();
    this._slidesGroups[slideId].setPos(0, 0);
    this._slidesGroups[slideId].setVisible(true);
};

GameInfo.prototype._hideAllSlides = function() {
    for(var i = 0; i < this._slidesGroups.length; i++) {
        this._slidesGroups[i].setVisible(false);
    }
};

// GameInfo.prototype.destroy = function() {
// 	for(var i in this._texts) {
// 		this._texts[i].destroy();
// 	}
// 	this._texts = {};
//
// 	for(var i = 0; i < this._objects.length; i++) {
// 		this._objects[i].destroy();
// 	}
// 	this._objects = [];
//
// 	/*for(var i = 0; i < this._slidesGroups.length; i++) {
// 		this._slidesGroups[i].destroy();
// 	}
// 	this._slidesGroups = [];*/
//
// 	this._logo.destroy();
// 	this._cover1.destroy();
// };